// extracted by mini-css-extract-plugin
module.exports = {"summary__stats":"H_cx","summary__stats__links":"H_cy","summary__stats__links__single":"H_cz"};